{
  "de": {
    "empty": {
      "headlines": {
        "default": "Keine Ergebnisse",
        "forName": "Keine %{name} gefunden",
        "hangar": "Ihr Hangar ist leer",
        "wishlist": "Ihre Wunschliste ist leer",
        "features": "Keine Funktionen verfügbar",
        "fleetFeatures": "Keine Flottenfunktionen verfügbar",
        "imports": "Keine Importe gefunden",
        "transfers": "Noch keine Transfers"
      },
      "actions": {
        "reset": "Filter/Seiten zurücksetzen",
        "resetPage": "Zur ersten Seite"
      },
      "texts": {
        "info": "Wir konnten keine Einträge finden.",
        "query": "It seems like you have some Filters active or visited a Page without any Records."
      },
      "info": {
        "hangar": "You can add Ships to your Hangar by clicking on the bookmark icon in the top right corner of a Ship or by using the Plus Button in the bottom right corner.",
        "extension": "Additionally you can import your Hangar from the RSI Website via the Fleetyards Sync Browser extension.",
        "wishlist": "You can add Ships to your Wishlist by clicking on the bookmark icon in the top right corner of a Ship.",
        "features": "Derzeit sind keine Self-Service-Funktionen verfügbar. Schauen Sie später wieder vorbei, da regelmäßig neue Funktionen hinzugefügt werden.",
        "fleetFeatures": "Derzeit gibt es keine Funktionen, die eine Flotte selbst einschalten kann. Schauen Sie später wieder vorbei, da regelmäßig neue Funktionen hinzugefügt werden."
      },
      "payouts": {
        "entries": "Noch nichts erfasst",
        "participants": "Noch niemand auf dieser Tour",
        "transfers": "Rechne ab, um zu sehen wer wem zahlt",
        "tours": "Noch keine Touren"
      },
      "fleets": {
        "contracts": {
          "items": "Noch keine Waren. Füge hinzu, was dieser Auftrag verlangt — leer kann er nicht veröffentlicht werden."
        },
        "events": {
          "upcoming": "Nichts geplant",
          "past": "Noch keine vergangenen Events",
          "archived": "Nichts archiviert",
          "info": {
            "upcoming": "Erstelle ein Event, um die Flotte zusammenzubringen — Zeit festlegen, Slots anlegen, Mitglieder anmelden lassen.",
            "past": "Ein Event landet hier, sobald seine Endzeit vorbei ist.",
            "archived": "Archivieren nimmt ein Event von der Liste, ohne es zu löschen."
          }
        },
        "missions": {
          "active": "Noch keine Missionen",
          "archived": "Nichts archiviert",
          "info": {
            "active": "Eine Mission ist ein wiederverwendbarer Plan — Teams, Schiffe und Slots — aus dem du Events erzeugst.",
            "archived": "Archivieren nimmt eine Mission von der Liste, ohne sie zu löschen."
          }
        }
      }
    }
  }
}
